import MundialRequestTask from "./MundialRequestTask";

export class ScheduleTask  extends MundialRequestTask {
  timeFrom: string;
  timeTo: string;

  constructor(timeFrom: string, timeTo: string) {
    super();
    this.timeFrom = timeFrom;
    this.timeTo = timeTo;
  }

  getUrl() {
    const baseUrl = this.getBaseUrl(); 
    return `${baseUrl}/leagues/${this.leagueId}/schedule-results`;
  }

  getParams() {
    const params = super.getParams();
    return {
      timeFrom: this.timeFrom,
      timeTo: this.timeTo,
      ...params
    };
  }
}


// WEBPACK FOOTER //
// ./src/mundial/requests/tasks/ScheduleTask.ts